import React, { useMemo, useState } from "react";
import "./FirstAdCard.css";
import HouseAdCard from "./HouseAdCard";
import useAdBannerAnalytics from "../../hooks/useAdBannerAnalytics";

const getCreativeKey = (ad) => {
  if (!ad) return "";

  return `${ad.campaignId || ""}:${ad.creativeId || ""}:${
    ad.creativeUrl || ""
  }`;
};

const FirstAdCard = ({
  ad = null,
  houseAd = null,
  mobileDividerEdge = "top",
  surface = "home",
  device = "desktop",
  analyticsSlot = "first",
  viewabilityEnabled = true,
}) => {
  const creativeKey = useMemo(() => getCreativeKey(ad), [ad]);
  const [failedCreativeKey, setFailedCreativeKey] = useState("");

  const hasCommercialAd = Boolean(ad);
  const commercialAdIsRenderable =
    hasCommercialAd &&
    Boolean(creativeKey) &&
    failedCreativeKey !== creativeKey;
  const houseAdIsRenderable =
    !hasCommercialAd &&
    houseAd?.enabled === true &&
    houseAd?.firstEnabled === true;

  const {
    viewabilityRef,
    onClick: onBannerClick,
    onFailed: onBannerFailed,
  } = useAdBannerAnalytics({
    ad: hasCommercialAd ? ad : null,
    houseAd: houseAdIsRenderable ? houseAd : null,
    enabled: commercialAdIsRenderable || houseAdIsRenderable,
    surface,
    device,
    placement: "first",
    slotKey: analyticsSlot,
    viewabilityEnabled,
  });

  if (!commercialAdIsRenderable && !houseAdIsRenderable) {
    return null;
  }

  const altText =
    ad?.altText || ad?.brandName || "تبلیغ در چه‌خبره";

  return (
    <div
      ref={viewabilityRef}
      className={`first-ad-card-slot first-ad-card-slot--divider-${
        mobileDividerEdge === "bottom" ? "bottom" : "top"
      }`}
    >
      {commercialAdIsRenderable ? (
        <a
          className="first-ad-card"
          href={ad.targetUrl}
          target="_blank"
          rel="noopener noreferrer sponsored"
          onClick={onBannerClick}
          aria-label={`تبلیغ${ad.brandName ? ` ${ad.brandName}` : ""}`}
          data-ad-banner-type="commercial"
          data-ad-placement="first"
          data-ad-campaign-id={String(ad.campaignId)}
          data-ad-creative-id={String(ad.creativeId)}
        >
          <img
            className="first-ad-card__creative"
            src={ad.creativeUrl}
            alt={altText}
            loading="eager"
            decoding="async"
            onError={() => {
              onBannerFailed();
              setFailedCreativeKey(creativeKey);
            }}
          />

          <span className="first-ad-card__label" aria-hidden="true">
            تبلیغ
          </span>
        </a>
      ) : (
        <HouseAdCard
          houseAd={houseAd}
          placement="first"
          onClick={onBannerClick}
        />
      )}
    </div>
  );
};

export default FirstAdCard;
